import React from 'react'
import ReactPaginate from 'react-paginate'

import Layout from '../components/layout'
import ArticleList from '../components/pages/blog/ArticleList'
import SocialLinks from '../components/pages/blog/SocialLinks'
import LatestArticles from '../components/pages/blog/LatestArticles'
import TagsList from '../components/pages/blog/TagsList'
import Billboard from '../components/Billboard'
import Seo from '../components/seo'

const Blog = (props) => {
  const { articles, pageCount, currentPage } = props.pageContext

  return (
    <Layout>
      <Seo title="Blog" description="Our AWS Our technical insights" />

      <Billboard className="Billboard--blog" color="white">
        <div className="Billboard__top">
          <h1 className="Billboard__title">Expert aws cloud insights</h1>
          <div className="Billboard__lead">Designing for Scale</div>

          <div className="Billboard__cta" />
        </div>
      </Billboard>

      <section className="section blogWrap">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <ArticleList articles={articles} />

              <div className="pagination-wrap">
                <ReactPaginate
                  containerClassName="pagination"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-link"
                  nextClassName="page-link"
                  activeClassName="active"
                  activeLinkClassName="active"
                  previousLabel="Prev"
                  forcePage={currentPage}
                  pageCount={pageCount}
                  marginPagesDisplayed={0}
                  pageRangeDisplayed={5}
                  hrefBuilder={(pageIndex) => {
                    return pageIndex === 1
                      ? '/blog'
                      : `/blog/page/${pageIndex}/`
                  }}
                  disableInitialCallback={true}
                  onPageChange={(data) => {
                    window.location =
                      data.selected === 0
                        ? '/blog'
                        : `/blog/page/${data.selected + 1}/`
                  }}
                />
              </div>
            </div>

            <div className="col-md-4">
              <div className="blogSidebar">
                <LatestArticles />
                <SocialLinks />
                <TagsList />
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default Blog
